<template>
  <div class="button-group">
    <button :class="disabled ? 'success hollow button' : 'warning hollow button'" @click.stop="toggle"><i :class="disabled ? 'icon icon-lock' : 'icon icon-unlocked'"></i></button>
    <button :class="disabled ? 'secondary button' : 'warning button'" @click.stop="submit" :disabled="disabled ? 'disabled' : false">{{ 'Approve' }}</button>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'ConfirmDomainPendingCreate',
    data() {
      return {
        disabled: true,
      }
    },
    props: {
      domain: null,
    },
    methods: {
      toggle() {
        this.disabled = !this.disabled
      },
      submit() {
        api.approvePendingDomainCreateRequest(
          {domain: this.domain},
          () => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Domain %s has been approved.",
              args: [this.domain]
            }, {root: true});
            router.go()
          }
        )
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ConfirmDomainPendingCreate.vue